import React from 'react';

const BonsPlansJeunesFilterReset = ({ BonsPlansJeunesOnReset, BonsPlansJeunesResetShow }) => {
	// Validation des props
	if (!BonsPlansJeunesOnReset || typeof BonsPlansJeunesOnReset !== 'function') {
		return null;
	}

	return (
		<div 
			className="agenda-filter-reset"
			role="group"
			aria-label="Réinitialisation des filtres"
			aria-describedby="filter-reset-description"
		>
			<div id="filter-reset-description" className="visually-hidden">
				Bouton pour réinitialiser tous les filtres appliqués aux bons plans jeunes
			</div>
			<button 
				onClick={BonsPlansJeunesOnReset}
				className={BonsPlansJeunesResetShow ? 'btn btn-primary btn-lg btn-pink-3 btn-show' : 'btn btn-primary btn-lg btn-pink-3 btn-hide'}
				aria-label="Réinitialiser tous les filtres des bons plans jeunes"
				aria-describedby="filter-reset-description"
				aria-pressed={BonsPlansJeunesResetShow || false}
			>
				Réinitialiser les filtres
			</button>
		</div>
	);
};

export default BonsPlansJeunesFilterReset;
